module.exports = __webpack_public_path__ + "img/user_icon.9e26df6a.png";